import callflowQueryKeys from 'app/hooks/queries/callflow/callflowQueryKeys';
import mediaQueryKeys from 'app/hooks/queries/media/mediaQueryKeys';
import { useMutation, useQueryClient } from 'react-query';
import { useAuthSelector } from 'app/data/auth';
import { sdk } from 'app/sdk';
import { MediaUploadPayload } from 'types/media';

export const useUploadMedia = () => {
  const authState = useAuthSelector();
  const queryClient = useQueryClient();
  return useMutation(
    async (mediaUploadPayload: MediaUploadPayload) =>
      sdk.media.mutate.upload(mediaUploadPayload, authState?.auth_token),
    {
      onSuccess: async () => {
        await queryClient.invalidateQueries(mediaQueryKeys.all);
        await queryClient.invalidateQueries(callflowQueryKeys.all);
      },
    },
  );
};
